/**
 * Created by jomsm on 26/07/2017.
 */
(function () {
    angular.getObjVal = (obj, child) => {
        if(!obj)
            return obj;
        let nodes = child.split('.');
        let val = obj;
        nodes.every((node) => {
            val = val[node];
            return val;
        });

        return val;
    };
})();

(function () {
    angular.getObjDiff = (obj1, obj2) => {
        let diffs = {};
        angular.forEach(obj1, function (val, key) {
            let hasMatch = false;
            angular.forEach(obj2, function (v, k) {
                if(key === k && angular.equals(val,v) ){
                    hasMatch = true;
                }
            });
            if(!hasMatch)
                angular.extend(diffs, {
                    [key]: val
                });
        });
        return diffs;
    };
})();


// WEBPACK FOOTER //
// ./js/consts/getObjVal.js